import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BuildingService } from 'src/app/services/building.service';
import { DataService } from 'src/app/services/data.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-modal-database-use-authorization',
  templateUrl: './modal-database-use-authorization.component.html',
  styleUrls: ['./modal-database-use-authorization.component.scss']
})
export class ModalDatabaseUseAuthorizationComponent implements OnInit {
  data: { building: { id: string, name: string }, user: { id: string } };
  isLoading: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<ModalDatabaseUseAuthorizationComponent>,
    @Inject(MAT_DIALOG_DATA) public payload: { building: { id: string, name: string }, user: { id: string } },
    private buildingService: BuildingService,
    private dataService: DataService
  ) {
    this.data = this.payload;
  }

  ngOnInit(): void {
  }


  onEventVerify(event: boolean) {
    this.updateUserDatabaseCertificationContent(event);
  }

  onEventClose() {
    this.dialogRef.close();
  }

  updateUserDatabaseCertificationContent(enable: boolean) {
    this.isLoading = true;
    this.buildingService.updateBuildingDatabaseCertificationContent(enable).subscribe({
      next: (res) => {
        this.dataService.updateUserDatabaseCertificationContent(enable);
        this.dialogRef.close(true);
        this.isLoading = false;
      },
      error: (err) => {
        this.dataService.updateUserDatabaseCertificationContent(false);
        this.dialogRef.close(false);
        this.isLoading = false;
      }
    });
  }
}
